import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinusCircle } from '@fortawesome/pro-regular-svg-icons'

type FilePreviewProps = {
  file: File | null | ''
  onDelete: () => void
}

const FilePreview: React.FC<FilePreviewProps> = (props) => {
  if (!props.file) return null

  return (
    <div className="relative mb-3">
      <span
        onClick={props.onDelete}
        className="absolute -right-1 -top-1 flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-brand-500 p-2"
      >
        <FontAwesomeIcon className="h-5 w-5 text-white" icon={faMinusCircle} />
      </span>
      <p className="rounded-md bg-gray-50 p-2 text-sm text-gray-700">{`File: ${props.file.name} - ${
        (Math.round(props.file.size / 1024), 2)
      }MB`}</p>
    </div>
  )
}

export default FilePreview
